module.exports = __webpack_public_path__ + "static/media/Construction.b985fd03.jpg";